<template>
    <div>
        <div
            @click.self="isOpenedRequestDropdown = false"
            class="poi-modal__row"
        >
            <p class="poi-modal__text">
                {{ addGroupModal.textGroupName }}
                <span style="color: red">*</span>
            </p>
            <base-text-input
                view="primary"
                :placeholder="addGroupModal.textGroupNamePlaceholder"
                v-model.trim="groupName"
            />
        </div>

        <slot name="icons" />

        <div class="poi-modal__actions">
            <LinceButton
                class="poi-modal__cancel"
                :view="'square'"
                :theme="'border'"
                @click="onCloseModal"
            >
                {{ addGroupModal.textCancel }}
            </LinceButton>
            <LinceButton
                :view="'square'"
                :theme="'secondary'"
                :disabled="isDisabled"
                @click="onCreateNewMoiPoiGroup"
            >
                {{ addGroupModal.textStartCreateMoiPoint }}
            </LinceButton>
        </div>
    </div>
</template>

<script>
import BaseTextInput from "@/components/Base/BaseTextInput";
import containerPoiSchemes from "../../schemes/SchemeWidgetMap";
const { containerPoi } = containerPoiSchemes;

export default {
    name: "AddMoiPoiModalContent",

    components: {
        
        BaseTextInput,
    },

    data: () => ({
        addGroupModal: containerPoi.addGroupModal,
        groupName: "",
    }),

    computed: {
        isDisabled() {
            return this.groupName.length === 0;
        },
    },

    methods: {
        onInput(value) {
            this.groupName = value;
        },

        onCloseModal() {
            this.$emit("onCloseModal");
        },

        onCreateNewMoiPoiGroup() {
            const requestCreateGroupParams = {
                name: this.groupName,
            };

            this.$emit("onCreateNewMoiPoiGroup", requestCreateGroupParams);
        },

        onStartAddingPoints() {
            this.onCreateNewMoiPoiGroup();
            this.$emit("onStartAddingPoints");
        },
    },
};
</script>
